import ResponsiveImage from 'components/Common/ResponsiveImage'
import { rem } from 'polished'
import React from 'react'
import styled, { CSSProperties } from 'styled-components'

interface Props extends React.SVGAttributes<SVGSVGElement> {}

const Container = styled.div`
  display: grid;
  grid-template: 1fr / 1fr;
  place-items: center;
  width: var(--w);
`

const MWEBResponsiveImage = styled(ResponsiveImage)`
  grid-column: 1 / -1;
  grid-row: 1 / -1;

  > img {
    max-width: var(--w);
    object-fit: contain;
  }
`

function MWEBLuxuryEscapesLogo(props: Props) {
  return (<Container style={{ '--w': props.width ? rem(props.width) : undefined } as CSSProperties}>
    <MWEBResponsiveImage id="mweb-logo" height={props.height} dpr={3} disablePlaceholder />
  </Container>
  )
}

export default MWEBLuxuryEscapesLogo
